import React, { FC } from 'react';
import {
  Box,
  Card,
  MarketingLayout,
  SkeletonGroup,
  SkeletonLine,
} from '@wix/design-system';
import s from './CliTemplateCard.scss';

interface CliTemplateCardProps {}

export const CliSkeletonCard: FC<CliTemplateCardProps> = () => {
  return (
    <div role="button" tabIndex={0} className={s.cardWrapper}>
      <Card className={s.gridCard}>
        <MarketingLayout
          inverted
          size="tiny"
          alignItems="stretch"
          title={
            <Box marginBottom="7px">
              <SkeletonGroup>
                <SkeletonLine width="98px" />
              </SkeletonGroup>
            </Box>
          }
          description={
            <SkeletonGroup>
              <Box display="flex" direction="vertical" gap="6px">
                <SkeletonLine width="135px" />
                <SkeletonLine width="82px" />
              </Box>
            </SkeletonGroup>
          }
          imagePadding={false}
          image={
            <Box borderRight="1px solid #DFE5EB" width="110px" height="114px" />
          }
        />
      </Card>
    </div>
  );
};
